// mockApi.js

// Language options
export const LANGUAGES = {
	EN: 'en',
	CS: 'cs'
  };
  
  // Response types
  export const RESPONSE_TYPES = {
	STANDARD: 'standard',
	WEBSITE_LINK: 'website_link'
  };
  
  // Test scenarios
  export const TEST_SCENARIOS = {
	EN_STANDARD: 'en_standard',
	EN_WEBSITE: 'en_website',
	CS_STANDARD: 'cs_standard',
	CS_WEBSITE: 'cs_website',
	ERROR: 'error',
	TIMEOUT: 'timeout',
	NETWORK_ERROR: 'network_error',
	CUSTOM: 'custom'
  };
  
  export const createMockApi = (config = {}) => {
	const {
	  shouldFail = false,
	  delayMs = 1000,
	  customResponse = null,
	  simulateTimeout = false,
	  simulateNetworkError = false,
	  language = LANGUAGES.EN,
	  responseType = RESPONSE_TYPES.STANDARD
	} = config;
  
	const loadMockResponse = async () => {
	  const version = responseType === RESPONSE_TYPES.WEBSITE_LINK ? 'b' : 'a';
	  const filename = `/test_data/${language.toLowerCase()}_response_${version}.json`;
	  
	  try {
		const response = await fetch(filename);
		if (!response.ok) {
		  throw new Error(`Failed to load mock response file: ${filename}`);
		}
		return await response.json();
	  } catch (error) {
		console.error('Error loading mock response file:', error);
		throw new Error(`Failed to load mock response: ${error.message}`);
	  }
	};
  
	return {
	  async query(data) {
		// Simulate network delay
		await new Promise(resolve => setTimeout(resolve, delayMs));
  
		// Simulate timeout
		if (simulateTimeout) {
		  throw new Error('AbortError');
		}
  
		// Simulate network error
		if (simulateNetworkError) {
		  throw new Error('NetworkError');
		}
  
		// Simulate API error
		if (shouldFail) {
		  throw new Error('API Error: Something went wrong');
		}
  
		try {
		  // Use custom response if provided, otherwise load from file
		  const mockResponse = customResponse || await loadMockResponse();
  
		  // Simulate API response structure
		  return {
			content: [{
			  text: JSON.stringify(mockResponse)
			}],
			usage: {
			  input_tokens: 4527,
			  output_tokens: 923
			},
			model: 'claude-3-opus-20240229'
		  };
		} catch (error) {
		  console.error('Error in mock response:', error);
		  throw new Error(`Failed to generate mock response: ${error.message}`);
		}
	  }
	};
  };
  
  // Helper to get mock config based on scenario
  export const getMockConfig = (scenario, customConfig = {}) => {
	const baseConfig = {
	  delayMs: 1000
	};
  
	const scenarios = {
	  [TEST_SCENARIOS.EN_STANDARD]: {
		...baseConfig,
		language: LANGUAGES.EN,
		responseType: RESPONSE_TYPES.STANDARD
	  },
	  [TEST_SCENARIOS.EN_WEBSITE]: {
		...baseConfig,
		language: LANGUAGES.EN,
		responseType: RESPONSE_TYPES.WEBSITE_LINK
	  },
	  [TEST_SCENARIOS.CS_STANDARD]: {
		...baseConfig,
		language: LANGUAGES.CS,
		responseType: RESPONSE_TYPES.STANDARD
	  },
	  [TEST_SCENARIOS.CS_WEBSITE]: {
		...baseConfig,
		language: LANGUAGES.CS,
		responseType: RESPONSE_TYPES.WEBSITE_LINK
	  },
	  [TEST_SCENARIOS.ERROR]: {
		...baseConfig,
		shouldFail: true
	  },
	  [TEST_SCENARIOS.TIMEOUT]: {
		...baseConfig,
		simulateTimeout: true
	  },
	  [TEST_SCENARIOS.NETWORK_ERROR]: {
		...baseConfig,
		simulateNetworkError: true
	  },
	  [TEST_SCENARIOS.CUSTOM]: {
		...baseConfig,
		...customConfig
	  }
	};
  
	return scenarios[scenario] || scenarios[TEST_SCENARIOS.EN_STANDARD];
  };